import { ToggleButton } from '@mui/material'
import Remove from '@mui/icons-material/Remove'
import { useTiptapEditor } from 'ra-input-rich-text'
import { HorizontalRuleButtonProps } from './type'

export const HorizontalRuleButton: React.FC<HorizontalRuleButtonProps> = (props) => {
  const editor = useTiptapEditor()
  return editor ? (
    <ToggleButton
      value='hr'
      aria-label='Add an horizontal rule'
      title='Add an horizontal rule'
      disabled={!editor?.isEditable}
      onClick={(): unknown => editor.chain().focus().setHorizontalRule().run()}
      selected={editor && editor.isActive('horizontalRule')}
      {...props}
    >
      <Remove fontSize='inherit' />
    </ToggleButton>
  ) : null
}
